// https://stackoverflow.com/a/47752730/5627920
export const groupedMap = (list, key) => {
  return list.reduce((entryMap, e) => entryMap.set(e[key], [...(entryMap.get(e[key]) || []), e]), new Map());
};

export default { groupedMap };
